mutation DiscardHeldUpdates($attendeeId: ID!) {
  discardHeldUpdates(input: { attendeeId: $attendeeId }) {
    attendee {
      id
      heldUpdateCount
    }
  }
}
